import { LinkModel } from '@/types';
import { NextRouter } from 'next/router';

export const isExternalLink = (link: LinkModel) => {
  if (link) {
    const { href } = link;
    return (
      href &&
      (href.toLowerCase().startsWith('http://') ||
        href.toLowerCase().startsWith('https://') ||
        href.toLowerCase().startsWith('//') ||
        href.toLowerCase().startsWith('mailto:'))
    );
  }
  return true;
};

export const openLink = (router: NextRouter, link: LinkModel) => {
  if (link) {
    const { href, target } = link;
    if (!href) return;
    if (target && target === '_blank') {
      window.open(href, '_blank')?.focus();
    } else if (isExternalLink(link)) {
      window.location.href = href;
    } else {
      router.push(href);
    }
  }
};

export const isValidHttpUrl = (string: string) => {
  let url = null;

  if (string && string.length > 0) {
    try {
      url = new URL(string);
    } catch (e) {
      if (!e) console.trace(e);
      return false;
    }
  } else {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

// convert absolute URLs to relative if same host
export const convertAbsoluteLinkToRelative = (link?: LinkModel, realHost?: string) => {
  if (link && link.href && isExternalLink(link)) {
    let currentHost = null;
    let currentHostUrl = null;
    if (process.env.NODE_ENV === 'development') {
      currentHost =
        process.env.NEXT_PUBLIC_DEV_FRONTEND_HOST !== ''
          ? process.env.NEXT_PUBLIC_DEV_FRONTEND_HOST
          : 'https://uat.testing-stylus.com/';
    } else {
      if (typeof window === 'undefined') {
        currentHost = realHost;
      } else {
        currentHost = window?.location?.origin;
      }
    }

    if (currentHost) {
      try {
        currentHostUrl = new URL(currentHost);
      } catch (e) {
        console.warn('Invalid URL: ' + currentHost, e);
      }

      if (currentHostUrl) {
        let linkUrl = null;

        if (link.href) {
          try {
            linkUrl = new URL(link.href);
          } catch (e) {
            console.warn('Invalid URL: ' + link.href, e);
          }
          if (linkUrl) {
            if (currentHostUrl.host === linkUrl.host) {
              return { ...link, href: linkUrl.pathname + linkUrl.search + linkUrl.hash };
            }
          }
        }
      }
    }
  }
  return link;
};

export const getUrlExtension = (url: string) => {
  return url.split(/[#?]/)[0].split('.').pop()?.trim().toLowerCase();
};

export const removeLinkQueryParams = (url: string) => {
  const asPathUrl = new URL(url, 'http://example.com');
  asPathUrl.search = '';
  return asPathUrl.pathname + asPathUrl.hash;
};

export const isStatBankGDLink = (link: LinkModel) => {
  const linksList = [
    'https://app.stylus.com/globaldata-sources-method',
    'https://uat-app.testing-stylus.com/globaldata-sources-method',
    'globaldata.com',
  ];

  if (link && link.href) {
    const href = link.href.toLowerCase();
    return linksList.some((gdLink) => {
      const validHttpUrl = isValidHttpUrl(href);
      if (validHttpUrl) {
        return href.includes(gdLink.toLowerCase());
      } else {
        try {
          const gdLinkUrl = new URL(gdLink);
          return gdLinkUrl.pathname && gdLinkUrl.pathname.toLowerCase() === href.split('?')[0].toLowerCase();
        } catch (_) {
          return false;
        }
      }
    });
  }
  return false;
};
